import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'react-bootstrap-5';
import ActivityLog from './activity_log';
import Owners from './owners';
import PropertyDetails from './property_details';
import { Provider } from 'react-redux';

import configureStore from './store/configure';
import Tasks from './tasks';
import NotesCard from './notes';
import QuickLinks from './quick_links';
import Contact from './contact';
import Portfolio from './portfolio';

export default function CallListItem(
  { activities, callListId, callListItems, callTemplates, recordId, recordType, insightsPropertyId }
) {
  const store = useMemo(() => configureStore({ activities, owners: null, insightsPropertyId }), []);

  return (
    <Provider store={store}>
      <Container fluid>
        <Row className="gy-6">
          <Col className="order-2 order-lg-1 d-flex flex-column gap-4" lg={4} sm={6} xl={3}>
            {!insightsPropertyId ? <Contact contactId={recordId}/> : <Owners/>}
            {!insightsPropertyId && <Portfolio contactId={recordId}/>}
          </Col>
          <Col className="order-1 order-lg-2" lg={8} xl={6}>
            <div className="d-flex flex-column gap-4">
              <ActivityLog
                callListId={callListId}
                callTemplates={callTemplates}
                recordId={recordId}
                recordType={recordType}
              />
              {!insightsPropertyId ?
                <QuickLinks initialCallListItems={callListItems} /> :
                <PropertyDetails initialCallListItems={callListItems} insightsPropertyId={insightsPropertyId}/>
              }
            </div>
          </Col>
          <Col className="d-flex flex-column gap-4 order-3 offset-lg-4 offset-xl-0" lg={8} sm={6} xl={3}>
            <Tasks
              callListId={callListId}
              callTemplates={callTemplates}
              recordId={recordId}
              recordType={recordType}
            />
            <NotesCard
              recordId={recordId}
              recordType={recordType}
            />
          </Col>
        </Row>
      </Container>
    </Provider>
  );
}

CallListItem.propTypes = {
  activities: PropTypes.array.isRequired,
  callListId: PropTypes.number.isRequired,
  callListItems: PropTypes.array.isRequired,
  callTemplates: PropTypes.array.isRequired,
  insightsPropertyId: PropTypes.number,
  recordId: PropTypes.number.isRequired,
  recordType: PropTypes.string.isRequired
};
